import type { MachineExtraction } from '@indutrust/machine-model';

/** Minimal shape required by extraction helpers. */
export type MachineExtractionSource = {
  extraction?: MachineExtraction;
};

const ACTIVE_EXTRACTION_STATUSES = new Set(['pending', 'processing']);

/** True when the datasheet extraction job is still running. */
export function isMachineExtractionActive(
  machine: MachineExtractionSource
): boolean {
  const status = machine.extraction?.status;
  return status !== undefined && ACTIVE_EXTRACTION_STATUSES.has(status);
}

/** True when extraction completed and at least one suggestion id is present. */
export function hasMachineExtractionSuggestions(
  machine: MachineExtractionSource
): boolean {
  const { extraction } = machine;
  if (extraction?.status !== 'completed') {
    return false;
  }
  return extraction.suggested_capability_ids.length > 0;
}

/** Counts pending suggestion capability leaf ids. */
export function countMachineExtractionSuggestions(
  machine: MachineExtractionSource
): number {
  const { extraction } = machine;
  if (extraction?.status !== 'completed') {
    return 0;
  }
  return extraction.suggested_capability_ids.length;
}
